import { RPCs } from "../../../services/rpc.js";
import { NoResults } from "../../../components/NoResults/NoResults.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
import { ErrorLoadingRetry } from "../../../components/ErrorLoadingRetry.js";
import { useRegionTimezone } from "../../Regions/hooks/useRegionTimezone.js";
import { useLocationContext } from "../../Locations/contexts/LocationContext.js";
import { ServicePeriodInstanceCard } from "../instance/ServicePeriodInstanceCard.js";
import { useActivityEvals } from "../hooks/useActivityEvals.js";
import { buildNowInstanceQueryArgs } from "../queries/instance-query.js";
import { groupInstancesByStartCalendarDay } from "../queries/group-instances-by-day.js";
import { partitionOpenInstances } from "../queries/partition-open-instances.js";
import { useState } from "react";
import { Loading } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { RiCalendarScheduleFill } from "react-icons/ri";
//#region src/modules/ServicePeriods/location-panel/ServicePeriodNowList.tsx
function ServicePeriodNowList() {
	const { location, locationId } = useLocationContext(true);
	const timezone = useRegionTimezone(location.regionId);
	const [nowIso] = useState(() => (/* @__PURE__ */ new Date()).toISOString());
	const { call, data, error, isCalling, success } = useRPC(RPCs.ServicePeriods.FindServicePeriodInstances.v1, buildNowInstanceQueryArgs({
		locationId,
		nowIso,
		pagination: {
			limit: 500,
			skip: 0
		}
	}));
	const { current, upcoming } = partitionOpenInstances(data?.servicePeriodInstances ?? [], nowIso);
	const upcomingGroups = groupInstancesByStartCalendarDay(upcoming, timezone);
	const rows = [...current, ...upcoming];
	const evals = useActivityEvals({
		locationId,
		sourceRefIds: rows.map((instance) => instance.id)
	});
	return /* @__PURE__ */ jsxs("div", {
		className: "relative mt-xs",
		children: [
			/* @__PURE__ */ jsx(Loading, {
				overlay: true,
				size: "xxl",
				visible: isCalling && !rows.length
			}),
			error && /* @__PURE__ */ jsx("div", {
				className: "mb-xs",
				children: /* @__PURE__ */ jsx(ErrorLoadingRetry, { onRetry: call })
			}),
			evals.error && /* @__PURE__ */ jsx("div", {
				className: "mb-xs",
				children: /* @__PURE__ */ jsx(ErrorLoadingRetry, { onRetry: evals.call })
			}),
			!isCalling && success && !rows.length && /* @__PURE__ */ jsx(NoResults, {
				iconName: RiCalendarScheduleFill,
				text: "No current or upcoming service periods"
			}),
			!!current.length && /* @__PURE__ */ jsxs("section", {
				className: "mb-base flex flex-col gap-sm",
				children: [/* @__PURE__ */ jsx("div", {
					className: "text-color-subtle text-sm font-medium",
					children: "Happening now"
				}), current.map((instance) => /* @__PURE__ */ jsx(ServicePeriodInstanceCard, {
					instance,
					runtimeActivityEvals: evals.bySourceRefId[instance.id]
				}, instance.id))]
			}),
			!!upcomingGroups.length && /* @__PURE__ */ jsxs("section", {
				className: "flex flex-col gap-base",
				children: [/* @__PURE__ */ jsx("div", {
					className: "text-color-subtle text-sm font-medium",
					children: "Future"
				}), upcomingGroups.map((group) => /* @__PURE__ */ jsxs("div", {
					className: "flex flex-col gap-sm",
					children: [/* @__PURE__ */ jsx("div", {
						className: "text-color-subtle text-sm",
						children: group.label
					}), group.instances.map((instance) => /* @__PURE__ */ jsx(ServicePeriodInstanceCard, {
						instance,
						runtimeActivityEvals: evals.bySourceRefId[instance.id]
					}, instance.id))]
				}, group.dateKey))]
			})
		]
	});
}
//#endregion
export { ServicePeriodNowList };

//# sourceMappingURL=ServicePeriodNowList.js.map